import { isEmpty, isNil, path, prop } from 'ramda';

export function getCustomSuccessInfo(actionType: string | number, response: any) {

  const defaults = {
        'APP/CONTACT_SUCCESS':
            "Thank you! We've received your message and will respond soon",
        'APP/SUBSCRIBE_SUCCESS':
            'Subscription successful! Stay tuned for updates in your inbox',
        'APP/EVENTREG_SUCCESS':
            'Thank you for registering for the event! A confirmation email has been sent to you with further details.',
        'PRODUCT/PRODUCTENQ_SUCCESS':
            'Thank you for your inquiry! Our team has received your request and will get back to you shortly with the details',
    };

  const dynamicEventRegMsg =
      prop('eventRegistrationStatus', response) ||
      path(['data', 'message'], response) ||
      prop('message', response) ||
      defaults['APP/EVENTREG_SUCCESS'];

   const actionMsg: Record<string, any> = {
      'AUTH/SIGNIN_SUCCESS': prop('signInData', response),
      'APP/CONTACT_SUCCESS': defaults['APP/CONTACT_SUCCESS'],
      'APP/SUBSCRIBE_SUCCESS': defaults['APP/SUBSCRIBE_SUCCESS'],
      'APP/EVENTREG_SUCCESS': dynamicEventRegMsg,
      'PRODUCT/PRODUCTENQ_SUCCESS': defaults['PRODUCT/PRODUCTENQ_SUCCESS'],
      'AUTH/LOGIN_SUCCESS': path(['loggedInData', 'message'], response),
  };
  // if (isNil(actionMsg[actionType]) || isEmpty(actionMsg[actionType])) {
  //   return null;
  // }
  const msg = actionMsg[actionType as keyof typeof actionMsg];

  if (isNil(msg) || isEmpty(msg)) return null;

  return {
      code: '1',
      message: msg,
  };
}
